<template>
  <div
    v-if="discount"
    :class="{ largeFont: discount.toString().length < 5 ,'transparent':discountType == 'flat'}"
    class="discount__container"
    
  >
    <template v-if="discountType != 'flat'">
      <span class="large">{{ discount | price }}</span>
      <span class="small">{{ (discountType == "flat" ? "تومان" : "%")+" تخفیف" }}</span>
    </template>
    <!-- <img src="@/assets/images/discount.png" alt="discount" /> -->
  </div>
</template>
<script>
export default {
  props: {
    discount: Number,
    discountType: {
      type: String,
      default: "flat",
    },
  },
};
</script>

<style scoped>
.discount__container {
  left: 0;
  position: absolute;
  top: 0;
  z-index: 100;
  padding:2px 8px;
 /* background: rgb(254,94,53); */
  background: var(--color-red);
  color: white;
  font-weight: bolder;
  font-size: 16px;
  border-bottom-right-radius: 6px;
}
.transparent{
  background: transparent;
}
.discount__container img {
  width: 40px;
  position: absolute;
  left: 0;
  top: calc(100% - 5px);
  z-index: -1;
}
</style>
